var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"essay-container"},[_c('EssayTextArea',{attrs:{"question":_vm.essay}}),(_vm.feedback)?_c('AnswerFeedBack',{attrs:{"question":_vm.essay}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }